/**
 * @name Preview
 * @function
 * @description 시설안내
 */

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { ImgText } from "../components/ImgText";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const view = [
  {
    original: "http://choihyu.com/image/management1.jpg",
    thumbnail: "http://choihyu.com/image/management1.jpg",
  },
  {
    original: "http://choihyu.com/image/management2.jpg",
    thumbnail: "http://choihyu.com/image/management2.jpg",
  },
  {
    original: "http://choihyu.com/image/management3.jpg",
    thumbnail: "http://choihyu.com/image/management3.jpg",
  },

  {
    original: "http://choihyu.com/image/management4.jpg",
    thumbnail: "http://choihyu.com/image/management4.jpg",
  },
  {
    original: "http://choihyu.com/image/management6.jpg",
    thumbnail: "http://choihyu.com/image/management6.jpg",
  },
  {
    original: "http://choihyu.com/image/management5.jpg",
    thumbnail: "http://choihyu.com/image/management5.jpg",
  },
];
const deck = [
  {
    original: "http://choihyu.com/image/deck1.jpg",
    thumbnail: "http://choihyu.com/image/deck1.jpg",
  },
  {
    original: "http://choihyu.com/image/deck2.jpg",
    thumbnail: "http://choihyu.com/image/deck2.jpg",
  },
  {
    original: "http://choihyu.com/image/deck3.jpg",
    thumbnail: "http://choihyu.com/image/deck3.jpg",
  },
  {
    original: "http://choihyu.com/image/deck4.jpg",
    thumbnail: "http://choihyu.com/image/deck4.jpg",
  },
  {
    original: "http://choihyu.com/image/deck5.jpg",
    thumbnail: "http://choihyu.com/image/deck5.jpg",
  },
  {
    original: "http://choihyu.com/image/deck6.jpg",
    thumbnail: "http://choihyu.com/image/deck6.jpg",
  },
  {
    original: "http://choihyu.com/image/deck7.jpg",
    thumbnail: "http://choihyu.com/image/deck7.jpg",
  },
  {
    original: "http://choihyu.com/image/deck8.jpg",
    thumbnail: "http://choihyu.com/image/deck8.jpg",
  },
  {
    original: "http://choihyu.com/image/tent4.jpg",
    thumbnail: "http://choihyu.com/image/tent4.jpg",
  },
];
const sink = [
  {
    original: "http://choihyu.com/image/sink1.jpg",
    thumbnail: "http://choihyu.com/image/sink1.jpg",
  },
  {
    original: "http://choihyu.com/image/sink2.jpg",
    thumbnail: "http://choihyu.com/image/sink2.jpg",
  },
];
const bathroom = [
  {
    original: "http://choihyu.com/image/bathroom1.jpg",
    thumbnail: "http://choihyu.com/image/bathroom1.jpg",
  },
  {
    original: "http://choihyu.com/image/bathroom2.jpg",
    thumbnail: "http://choihyu.com/image/bathroom2.jpg",
  },
];
const shower = [
  {
    original: "http://choihyu.com/image/shower1.jpg",
    thumbnail: "http://choihyu.com/image/shower1.jpg",
  },
  {
    original: "http://choihyu.com/image/shower2.jpg",
    thumbnail: "http://choihyu.com/image/shower2.jpg",
  },
];

const previewList = [
  {
    title: "넓은 데크",
    content:
      "현재 4MX6M 데크 18면과, 5.4MX7.5M 8면을 갖추고 있으며, 데크간의 넓은 간격은 SUB차량이 충분히 주차할 수 있고, 옆데크와의 프라이버시를 보장합니다.",
    name: deck,
  },
  {
    title: "관리동",
    content:
      "관리동에는 관리실, 공용샤워실, 공용화장실, 개수대, 매점이 위치하고 있으며, 고객의 편리함을 최우선으로 설계되어 있습니다.",
    name: view,
  },
  {
    title: "개수대",
    content:
      "수세미와 주방세제가 비치되어 있으며, 여유있게 설치된 싱크대 공간은 쾌적함을 더해 줍니다.",
    name: sink,
  },
  {
    title: "샤워시설",
    content:
      "24시간 운영되는 샤워실은 온수를 상시 공급하며, 드라이기를 비치하여 편리하게 이용할 수 있습니다. 여러 사람이 이용하기에 충분한 공간을 확보하고 있고 락커를 설치하여 분실물을 방지할 수 있습니다.",
    name: shower,
  },
  {
    title: "화장실",
    content:
      "남자화장실, 여자화장실로 구분되어 있으며, 늘 쾌적한 상태를 유지하도록 관리하고 있습니다.",
    name: bathroom,
  },
];

export const Preview = (): JSX.Element => {
  useEffect(() => {
    AOS.init();
  });

  return (
    <div>
      <ImgText title="Preview" text="도심속의 휴식 공간" />
      <div className="flex flex-row justify-center pb-6">
        <div className="text-center flex flex-col ">
          {previewList.map((item, index) => {
            return (
              <div
                key={index}
                className="pt-8 sm:pt-14  max-w-[20rem] sm:max-w-[48rem]"
              >
                <p
                  className="font-extrabold text-xl sm:text-3xl text-point"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-anchor-placement="center-bottom"
                >
                  {item.title}
                </p>
                <p
                  className="text-sm sm:text-lg pt-3 sm:pt-6 text-wrap"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-anchor-placement="center-bottom"
                >
                  {item.content}
                </p>
                <div
                  className="pt-3 sm:pt-6 "
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-anchor-placement="center-bottom"
                >
                  <ImageGallery items={item.name} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
